import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';

export interface TagDriver extends BaseUniDriver {
  clickRemoveButton(): Promise<void>;

  hasCloseIcon(): Promise<boolean>;
  setForceHover(force: boolean): Promise<void>;
}

export const tagDriverFactory = (base: UniDriver): TagDriver => {
  return {
    ...baseUniDriverFactory(base),
    clickRemoveButton: () => base.click(),
    hasCloseIcon: () => base.$('[data-hook="remove-icon"]').exists(),
    setForceHover: async (force) =>
      base
        .getNative()
        .then((el) => el.setAttribute('data-force-hover', force ? 'true' : 'false')),
  };
};
